import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-main-modal',
  standalone: true,
  templateUrl: './main-modal.component.html',
  styleUrls: ['./main-modal.component.scss'],
})
export class MainModalComponent {
  @Input() title: string = '';
  @Output() close: EventEmitter<void> = new EventEmitter();

  onClose() {
    this.close.emit();
  }
}
